import { Badge } from '@monksflow/monks-ui';
import { ChevronRightIcon, CircleCheckIcon, TriangleAlertIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { categoricalBadgeClass } from '@/shared/ui/categoricalBadge';

interface OverviewCardProps {
  label: string;
  count: number;
  isLoading: boolean;
  onNavigate: () => void;
}

export const OverviewCard = ({ label, count, isLoading, onNavigate }: OverviewCardProps) => {
  const { t } = useTranslation('admin');

  const isConfigured = !isLoading && count > 0;

  return (
    <button
      type="button"
      onClick={onNavigate}
      className="group flex w-full cursor-pointer items-center justify-between rounded-lg px-4 py-3 text-left transition-colors duration-fast ease-out hover:bg-accent"
    >
      <span className="flex flex-row items-center gap-3">
        {isConfigured ? (
          <CircleCheckIcon className="size-5 text-positive-foreground" />
        ) : (
          <TriangleAlertIcon className="size-5 text-warning-foreground" />
        )}
        <span className="text-sm font-medium leading-5">{label}</span>
      </span>
      <span className="flex flex-row items-center gap-1">
        {isLoading ? null : (
          <Badge
            className={`${categoricalBadgeClass(isConfigured ? 'green' : 'orange')} font-normal text-muted-foreground`}
          >
            {isConfigured
              ? t('admin.toolConfigPage.countConfigured', { configuredCount: count })
              : t('admin.overviewCard.notConfigured')}
          </Badge>
        )}
        <ChevronRightIcon className="size-5 text-muted-foreground opacity-0 transition-opacity duration-fast ease-out group-hover:opacity-100" />
      </span>
    </button>
  );
};
